<template>
  <div class="nx-file-image-form-selector">
    <nx-file-image-selector
      v-bind="$attrs"
      :filters="filters"
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      v-validate:value="validation"
      data-vv-validate-on="input|blur"
      :disabled="disabled"
      :value="value"
      :label="label"
      :manual-hint-text="manualHintText"
      @input="onInput"
      @blur="onBlur"
      @focus="onFocus"
      :allowSearcher="allowSearcher"
      :collectionId="collectionId"
      :template="template"
      :error-messages="errorMessages"
    ></nx-file-image-selector>
  </div>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import FileImageSelector from '../FileImageSelector';

export default {
  name: 'nx-file-image-form-selector',
  mixins: [FormElement],
  components: {
    [FileImageSelector.name]: FileImageSelector,
  },
  props: {
    value: {
      type: [Object, Number, String],
    },
    filters: {
      type: Object,
    },
    size: {
      type: Number,
    },
    allowSearcher: {
      type: Boolean,
      default: false,
    },
    collectionId: {
      type: Number,
    },
    template: {
      type: String,
      default: 'lg',
    },
    manualHintText: {
      type: String,
    },
  },
  methods: {
    onInput(value, valueAsObject) {
      this.$parentForm.updateField(this.name, value);
      this.$emit('input', value, valueAsObject);
    },
    onBlur() {
      this.flags.focused = false;
    },
  },
};
</script>
